/**
 * PhoneTransferForm - Phone number transfer form component
 */
import { useTranslation } from 'react-i18next';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { COUNTRY_CODES } from './constants';

const PhoneTransferForm = ({ 
  countryCode, 
  setCountryCode, 
  phoneNumber, 
  setPhoneNumber 
}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-2">
      <Label htmlFor="phone-number">Recipient Phone Number</Label>
      <div className="flex gap-2">
        <Select value={countryCode} onValueChange={setCountryCode}>
          <SelectTrigger className="w-28 rounded-xl" data-testid="country-code-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COUNTRY_CODES.map((cc) => (
              <SelectItem key={cc.code} value={cc.code}>
                {cc.flag} {cc.code}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Input
          id="phone-number"
          type="tel"
          placeholder="555-123-4567"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          className="h-12 rounded-xl flex-1"
          data-testid="phone-number-input"
        />
      </div>
      <p className="text-xs text-muted-foreground" data-testid="phone-account-note">
        {t('notices.phoneAccountNote')}
      </p>
    </div>
  );
};

export default PhoneTransferForm;
